const ITEMS = ["FILM", "CONTENT", "BRAND", "TECHNOLOGY", "CULTURE", "AI"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((w) => (
      <span key={w} className="flex items-center">
        <span className="font-display font-bold uppercase tracking-tight text-4xl sm:text-6xl text-cream/90 px-8">{w}</span>
        <span className="font-display font-bold text-4xl sm:text-6xl text-acid">{"//"}</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="marquee-section" className="relative border-y border-line bg-ink py-6 overflow-hidden" aria-hidden="true">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);
